import React from "react";
import { GridBackdrop } from "./components/GridBackdrop";
import { ScrollProgress } from "./components/ScrollProgress";
import { TopBar } from "./components/TopBar";
import { Hero } from "./components/Hero";
import { VideoSection } from "./components/VideoSection";
import { ProblemSection } from "./components/ProblemSection";
import { CostCalculator } from "./components/CostCalculator/CostCalculator";
import { HowItWorks } from "./components/HowItWorks";
import { IncludedSection } from "./components/IncludedSection";
import { Differentiation } from "./components/Differentiation";
import { WhoItsFor } from "./components/WhoItsFor";
import { FoundingClient } from "./components/FoundingClient";
import { DiagnosisChecklist } from "./components/DiagnosisChecklist";
import { ApplicationWizard } from "./components/ApplicationWizard/ApplicationWizard";
import { FAQ } from "./components/FAQ";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";
import { StickyBar } from "./components/StickyBar";
import { useTrackingInit } from "./hooks/useTrackingInit";
import { useDocumentMeta } from "./hooks/useDocumentMeta";
import { LeakChecklist } from "./components/LeakChecklist";
export function App() {
  useDocumentMeta();
  useTrackingInit();
  return <div lang="es" className="relative min-h-screen w-full overflow-x-clip bg-ink font-sans text-cream" data-id="element-0" data-mp="67yhm9c7y5s">
      <ScrollProgress data-id="element-1" data-mp="2zlv32jnmchps" />
      <GridBackdrop data-id="element-2" data-mp="2zmo6bandcp36" />
      <div className="relative z-10" data-id="element-3" data-mp="2zn6cp03qwjot">
        <TopBar data-id="element-4" data-mp="33m5bs42spm8c" />
        <main data-id="element-5" data-mp="33nq5jrhad155">
          <Hero data-id="element-6" data-mp="33n6yj5t6bx5w" />
          <VideoSection data-id="element-7" data-mp="33oriy2lrxzq1" />
          <ProblemSection data-id="element-8" data-mp="38lrs4mdx7ild" />
          <WhoItsFor data-id="element-9" data-mp="38li6fazwrxlh" />
          <CostCalculator data-id="element-10" data-mp="38k6ugnwb7jja" />
          <HowItWorks data-id="element-11" data-mp="38o4fxg6d0n6c" />
          <IncludedSection data-id="element-12" data-mp="3dkl60fx4dbm2" />
          <Differentiation data-id="element-13" data-mp="3dlw4q1bpjt6b" />
          <LeakChecklist data-id="element-14" data-mp="3dm5ze27p6oic" />
          <FoundingClient data-id="element-15" data-mp="nvj2rdpwcaoo" />
          <DiagnosisChecklist data-id="element-16" data-mp="nwc2vvuco1xu" />
          <ApplicationWizard data-id="element-17" data-mp="nv0wrpdfmi3k" />
          <FAQ data-id="element-18" data-mp="nxx0jubyo0zx" />
          <FinalCTA data-id="element-19" data-mp="sudlkfnv5z8s" />
        </main>
        <Footer data-id="element-20" data-mp="stc8k5naf2of" />
      </div>
      <StickyBar data-id="element-21" data-mp="swqcvjfihlyi" />
    </div>;
}